import React, {useEffect, useState} from 'react';
import {Table, Button, Modal, Form, Input, InputNumber, Select, Tag, Menu, Dropdown} from 'antd';
import {t} from "i18next";
import {useUser} from "../../core/context/UserContext";
import {v4} from "uuid";
import Helper from "../../core/Helper";
import ApiService from "../../core/service/ApiService";

export const OperationSubItemsEdit = ({subItems, onSubItems, operationId, onExcelImported}) => {
    const [items, setItems] = useState([]);
    const {user} = useUser()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [form] = Form.useForm();

    const showModal = (item = null) => {
        setEditingItem(item);
        setIsModalVisible(true);
        if (item) {
            form.setFieldsValue(item);
        } else {
            form.resetFields();
        }
    };

    const handleOk = () => {
        form.validateFields().then(values => {
            if (editingItem) {
                setItems(items.map(item => (item.id === editingItem.id ? { ...values, id: editingItem.id } : item)));
            } else {
                setItems([...items, {
                    ...values,
                    id: v4(),
                    createdDate: new Date(),
                }]);
            }
            setIsModalVisible(false);
            setEditingItem(null);
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setEditingItem(null);
    };

    const handleDelete = id => {
        setItems(items.filter(item => item.id !== id));
    };

    const columns = [
        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('Price'),
            dataIndex: 'price',
            key: 'price',
            render: price => Helper.Currency.format(price),
        },
        {
            title: '#',
            key: 'actions',
            render: (_, record) => (
                <>
                    <Button size={'small'} onClick={() => showModal(record)}>{t('Edit')}</Button>
                    <Button size={'small'} onClick={() => handleDelete(record.key)} danger>{t('Delete')}</Button>
                </>
            ),
        },
    ];

    const downloadExcel = async () => {
        const res = await ApiService.Operation.GetOperationSubItemsExcel(operationId)
        if(res.success)
        {
            Helper.File.saveFile({
                blobLink: res.data,
                fileName: res.fileName
            })
        }
    }

    const uploadExcel = async (file) => {
        const res = await ApiService.Operation.UpdateOperationSubItemsExcel({
            excelBase64: file,
            operationId
        })

        // Sayfayı yeniden yüklemek yerine işlemi tekrar çek (alt işlemler + form).
        if (res?.success) onExcelImported && onExcelImported()
    }

    useEffect(() => {
        onSubItems(items);
    }, [items]);

    useEffect(() => {
        setItems(subItems)
    },[subItems])

    return (
        <>
            <Button size={'small'} onClick={() => showModal()}>+</Button>
            <Dropdown
                overlay={
                    <Menu>
                        <Menu.Item key="1" onClick={downloadExcel}>
                            {t('Export Excel')}
                        </Menu.Item>
                        <Menu.Item key="3" onClick={async () => {
                            const resFile = await Helper.File.getFileAsBase64({accept: '*.xlsx'});
                            if (resFile.data) {
                                Modal.confirm({
                                    closable: true,
                                    onOk: async () => {
                                        await uploadExcel(resFile.data, 1)
                                    },
                                    onCancel: async (args) => {},
                                    okText: t('Yes'),
                                    cancelText: t('No'),
                                    title: t('Update Operation Prices'),
                                    content: t('Do you want to continue to update operation prices?')
                                })
                            }
                        }}>
                            {t('Import Excel')}
                        </Menu.Item>
                    </Menu>
                }
            >
                <Button size={'small'} type={'primary'}>{t('Excel Operations')}</Button>
            </Dropdown>
            <Table
                size={'small'}
                columns={columns}
                dataSource={items}
                pagination={false}
            />
            <Modal
                title={editingItem ? t('Edit') : t('New')}
                open={isModalVisible}
                onOk={handleOk}
                okText={t('Save')}
                onCancel={handleCancel}
                cancelText={t('Cancel')}
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="name" label={t('Name')} rules={[{ required: true, message: t('Please input the name!') }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="price"
                        label={t('Price')}
                        rules={[{ required: true, message: t('Please input the price!') }]}
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};